import { useCallback, useEffect, useRef } from "react";

export function useIdleTimer(
  onIdle: () => void,
  timeout: number,
  enabled: boolean = true
) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = useCallback(() => {
    if (!enabled) return;

    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(onIdle, timeout);
  }, [enabled, onIdle, timeout]);

  useEffect(() => {
    if (!enabled) {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
      return;
    }

    const events = ["mousedown", "touchstart", "keydown"] as const;

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timer.current) clearTimeout(timer.current);
    };
  }, [enabled, resetTimer]);

  return resetTimer;
}
